import React, { useCallback } from 'react';

import { useAtom } from 'jotai';

import { MessageT } from '@consumer-frontend/api';
import { ListGroup } from '@consumer-frontend/shared-ui';

import { messageDetailPaginationAtom } from '../../store';
import { CnuMessageCenterLink } from '../CnuMessageCenterLink';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/message-center.scss';

export type CnuMessageCenterListGroupPropsT = {
  messages: MessageT[];
};
export type CnuMessageCenterListGroupT = React.FC<CnuMessageCenterListGroupPropsT>;

export const CnuMessageCenterListGroup: CnuMessageCenterListGroupT = ({ messages }) => {
  // TEMP PAGINATION HACK: revert once total count is fixed.
  // const [_, setMessageDetailPaginationValues] = useAtom(messageDetailPaginationAtom);
  const [_, setMessageDetailPaginationValues] = useAtom(messageDetailPaginationAtom);

  const handleClick = useCallback(
    (listOffset: number) => {
      setMessageDetailPaginationValues((values) => {
        return { ...values, offset: listOffset + values.offset };
      });
    },
    [setMessageDetailPaginationValues],
  );

  if (!messages.length) {
    return (
      <div className="cnu-message-center-empty">
        <p>No messages yet.</p>
      </div>
    );
  }

  return (
    <ListGroup className="cnu-message-center-list">
      {messages.map((message, idx) => (
        <CnuMessageCenterLink
          key={message.id}
          messageDate={message.sent_at}
          messageTitle={message.subject}
          onClick={() => handleClick(idx)}
        />
      ))}
    </ListGroup>
  );
};
